module.exports = __webpack_public_path__ + "assets/img/101201.6b31bed7.svg";